import React from "react";
import PropTypes from "prop-types";

import Table, {
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from "material-ui/Table";
import {
  dollarValue,
  fixed2,
  numberWithCommas,
  sumAvgMaxStats
} from "./helpers/presentation";

const OvTimeSummaryTable = props => {
  const { data } = props;

  const renderTableRows = () => {
    const obj = {
      instance_cost: sumAvgMaxStats(data.map(d => d.instance_cost)),
      license_cost: sumAvgMaxStats(data.map(d => d.license_cost)),
      storage_cost: sumAvgMaxStats(data.map(d => d.storage_cost)),
      minutes: sumAvgMaxStats(data.map(d => d.minutes)),
      cores: sumAvgMaxStats(data.map(d => d.cores)),
      storage: sumAvgMaxStats(data.map(d => d.storage))
    };

    return Object.keys(obj).map((key, i) => {
      const parts = key.split("_");
      let formatFunc = x => numberWithCommas(fixed2(x));

      if (parts.length === 2 || parts[1] === "cost") {
        formatFunc = dollarValue;
      }
      const o = obj[key];
      return (
        <TableRow key={i}>
          <TableCell>{key}</TableCell>
          <TableCell numeric>{formatFunc(o.max)}</TableCell>
          <TableCell numeric>{formatFunc(o.avg)}</TableCell>
          <TableCell numeric>{formatFunc(o.sum)}</TableCell>
        </TableRow>
      );
    });
  };

  return (
    <Table>
      <TableHead>
        <TableRow>
          <TableCell>Metric</TableCell>
          <TableCell numeric>Max</TableCell>
          <TableCell numeric>Avg</TableCell>
          <TableCell numeric>Total</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>{renderTableRows()}</TableBody>
    </Table>
  );
};

OvTimeSummaryTable.propTypes = {
  data: PropTypes.array.isRequired
};

export default OvTimeSummaryTable;



// WEBPACK FOOTER //
// ./src/OvTimeSummaryTable.js